var _rect, _g, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_626_7074",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_626_7074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 24C14.7166 24 14.4792 23.904 14.2879 23.712C14.0959 23.5207 13.9999 23.2833 13.9999 23V17L8.19991 9.6C7.94991 9.26667 7.91257 8.91667 8.08791 8.55C8.26257 8.18333 8.56657 8 8.99991 8H22.9999C23.4332 8 23.7376 8.18333 23.9129 8.55C24.0876 8.91667 24.0499 9.26667 23.7999 9.6L17.9999 17V23C17.9999 23.2833 17.9042 23.5207 17.7129 23.712C17.5209 23.904 17.2832 24 16.9999 24H14.9999ZM15.9999 16.3L20.9499 10H11.0499L15.9999 16.3Z",
    fill: "#616161"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.15b66d015d8a1e030c0588c997840e65.svg";
export { ForwardRef as ReactComponent };